import { render } from "./GreetingCard.vue?vue&type=template&id=28d7319a&scoped=true&ts=true"
import script from "./GreetingCard.vue?vue&type=script&lang=ts"
export * from "./GreetingCard.vue?vue&type=script&lang=ts"

import "./GreetingCard.vue?vue&type=style&index=0&id=28d7319a&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d7319a"]])

export default __exports__